import { ReactElement } from 'react';
import { useToggle } from '@client/common/hooks';
import { useCheckPermissions, useUserData } from '@client/context/hooks';
import { useTranslate } from '@client/i18n/hooks';
import { BUTTON_ICON_ICON_NAME, BUTTON_ICON_STYLE_TYPE, ButtonIcon } from 'b2b-components/theme/components/ButtonIcon';
import { Modal } from 'b2b-components/theme/components/Modal';
import { PERMISSION } from 'b2b-common/core/context/Context.types';
import { Props } from './PDFAction.types';
import { PDFForm } from './PDFForm';

export const PDFAction = ({ product }: Props): ReactElement | null => {
  const t = useTranslate();
  const [isModalOpened, setIsModalOpened] = useToggle();
  const { isLoggedIn, isPrivate } = useUserData();
  const hasUserPdfExportPermissions = useCheckPermissions([
    PERMISSION.productPdfExport,
  ]);

  const toggleModal = () => {
    setIsModalOpened();
  };

  if (!isLoggedIn || !hasUserPdfExportPermissions || isPrivate) {
    return null;
  }

  return (
    <>
      <ButtonIcon
        icon={BUTTON_ICON_ICON_NAME.pdf}
        styleType={BUTTON_ICON_STYLE_TYPE.secondary}
        onClick={toggleModal}
        dataAttributes={{ 'data-testid': 'printToPDFActionButton' }}
        title={t('PDF Export')}
      />
      <Modal
        title={t('PDF Export')}
        isOpen={isModalOpened}
        content={() => <PDFForm product={product} toggleModal={toggleModal} />}
        onCloseModal={toggleModal}
      />
    </>
  );
};
